import { useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useModelStore, useStiffeningStore } from '@editorStores'
import { getModel } from '@queries'
import { buildGuidToLabelMap } from './useElementLabel/utils'

const useElementLabel = () => {
  const { projectId } = useParams<{ projectId: string }>()
  const storeModel = useModelStore(state => state.model)
  const stiffeningIntervals = useStiffeningStore(state => state.stiffeningIntervals)

  const { data: queryModel } = useQuery({
    queryKey: getModel.getKey(projectId as string),
    queryFn: () => getModel.request(projectId as string),
    enabled: !!projectId,
  })

  const model = queryModel ?? storeModel

  const guidToLabel = useMemo(
    () => buildGuidToLabelMap(model, stiffeningIntervals),
    [model, stiffeningIntervals],
  )

  return useCallback((element: string) => guidToLabel[element] || element, [guidToLabel])
}

export { buildGuidToLabelMap } from './useElementLabel/utils'
export default useElementLabel
